import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-velda-languages-subnav',
    templateUrl: './velda-languages-subnav.component.html',
    styleUrls: ['./velda-languages-subnav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class VeldaLanguagesSubnavComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
